export const SHORT_DATE_PATTERN: RegExp = /^(0[1-9]|1[0-2])\/\d{4}$/;
export const EXTRA_SHORT_DATE_PATTERN: RegExp = /^(0[1-9]|1[0-2])\/\d{2}$/;
export const HEBREW_DATE_PATTERN: RegExp = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/;
export const DEFAULT_DATE_PATTERN: RegExp = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
export const ISO_DATE_PATTERN: RegExp = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;
export const ISO_TIME_PATTERN: RegExp =
  /^(?:2[0-3]|[01]?[0-9]):[0-5][0-9]:[0-5][0-9]$/; /** matches a 24 hrs format for example: "21:06:13" */
